import {createReducer, on} from '@ngrx/store';
import {AddressFormGroup} from '../data/model/address.model';
import * as addressAction from './address.actions';

export const addressFeatureKey = 'address';

export interface AddressState {
  originalAddress: AddressFormGroup | null;
  suggestedAddress: AddressFormGroup | null;
  originalSelected: boolean | null;
  enableAddressCollection: boolean;
  verifiedAddressRequired: boolean;
}

export const initialState: AddressState = {
  enableAddressCollection: true,
  originalAddress: null,
  suggestedAddress: null,
  originalSelected: null,
  verifiedAddressRequired: false,
};

export const reducer = createReducer(
  initialState,

  on(addressAction.setEnableAddressCollection, (state, action) => ({
    ...state,
    enableAddressCollection: action.enabled,
  })),

  on(addressAction.setVerifiedAddressRequired, (state, action) => ({
    ...state,
    verifiedAddressRequired: action.required,
  })),

  on(addressAction.selectOriginalAddress, (state, action) => ({
    ...state,
    originalSelected: action.originalSelected,
  })),

  on(
    addressAction.addOriginalAddress,
    addressAction.saveValidatedAddress,
    (state, action) => ({
      ...state,
      originalAddress: action.address,
    }),
  ),

  on(addressAction.addSuggestedAddress, (state, action) => ({
    ...state,
    suggestedAddress: action.address,
  })),

  on(addressAction.createAddressSuccess, (state, action) => ({
    ...state,
    originalAddress: {
      ...state.originalAddress,
      id: action.id,
    } as AddressFormGroup,
    suggestedAddress: {
      ...state.suggestedAddress,
      id: action.id,
    } as AddressFormGroup,
  })),
);

export const getEnableAddressCollection = (state: AddressState): boolean =>
  state?.enableAddressCollection;

export const getOriginalAddress = (
  state: AddressState,
): AddressFormGroup | null => state?.originalAddress;

export const getSuggestedAddress = (
  state: AddressState,
): AddressFormGroup | null => state?.suggestedAddress;

export const getVerifiedAddressRequired = (state: AddressState): boolean =>
  state.verifiedAddressRequired;

export const getSelectedAddress = (state: AddressState): AddressFormGroup => {
  if (!state) {
    return {} as AddressFormGroup;
  }
  const selectedAddress = state.originalSelected
    ? state.originalAddress
    : state.suggestedAddress;
  return selectedAddress || ({} as AddressFormGroup);
};
